// scripts/initializeFirestore.js
import { db } from '../firebase/config';
import { collection, doc, setDoc, deleteDoc, getDoc } from 'firebase/firestore';

export const initializeFirestoreCollections = async () => {
  try {
    console.log('🔄 Initializing Firestore collections...');
    
    // Create a sample chat to ensure collection exists
    const sampleChatId = 'sample_chat_for_initialization';
    const sampleChatRef = doc(db, 'chats', sampleChatId);
    
    const sampleChat = {
      id: sampleChatId,
      productId: 'sample_product_id',
      productName: 'Sample Product',
      productImage: '',
      
      // Participants
      buyerId: 'sample_buyer_id',
      buyerName: 'Sample Buyer',
      buyerEmail: 'buyer@example.com',
      
      sellerId: 'sample_seller_id',
      sellerName: 'Sample Seller',
      sellerEmail: 'seller@example.com',
      sellerVerified: true,
      
      // Chat metadata
      status: 'active',
      lastMessage: 'Sample conversation started',
      lastMessageTime: new Date(),
      createdAt: new Date(),
      updatedAt: new Date(),
      
      // Unread counts
      buyerUnread: 0,
      sellerUnread: 1,
      
      // For easy querying
      participants: ['sample_buyer_id', 'sample_seller_id'],
      participantsMap: {
        'sample_buyer_id': {
          name: 'Sample Buyer',
          email: 'buyer@example.com',
          role: 'buyer',
          unread: 0
        },
        'sample_seller_id': {
          name: 'Sample Seller',
          email: 'seller@example.com',
          role: 'seller',
          unread: 1
        }
      }
    };
    
    // Check if sample already exists
    const existing = await getDoc(sampleChatRef);
    if (!existing.exists()) {
      await setDoc(sampleChatRef, sampleChat);
      console.log('✅ Sample chat created for initialization');
      
      // Also create a sample message
      const sampleMessageRef = doc(db, 'chats', sampleChatId, 'messages', 'sample_message_1');
      const sampleMessage = {
        id: 'sample_message_1',
        chatId: sampleChatId,
        senderId: 'sample_buyer_id',
        senderName: 'Sample Buyer',
        senderRole: 'buyer',
        message: 'Hello, I am interested in this product',
        type: 'text',
        timestamp: new Date(),
        readBy: ['sample_buyer_id']
      };
      
      await setDoc(sampleMessageRef, sampleMessage);
      console.log('✅ Sample message created');
      
      // Delete the sample after creation (optional)
      setTimeout(async () => {
        await deleteDoc(sampleChatRef);
        console.log('🧹 Sample chat cleaned up');
      }, 5000);
    }
    
    console.log('✅ Firestore collections are ready!');
    return true;
    
  } catch (error) {
    console.error('❌ Error initializing Firestore:', error);
    return false;
  }
};